import { css } from '@emotion/core'

export const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    width: 400px;
    max-width: 88vw;

    user-select: none;
  `,

  navigation: {
    container: css`
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin-top: 4px;
      transition: 300ms;
    `,

    item: css`
      text-transform: uppercase;
      font-size: 12px;
      color: #777777;

      margin: 12px 0 0 0;
      cursor: pointer;

      &:focus {
        outline: none;
        text-decoration: underline;
      }
    `,

    active: css`
      font-weight: 800;
      color: #22303d;
      cursor: default;
      opacity: 0.75;
    `,
  },

  checkboxes: css`
    display: flex;
    flex-direction: column;
    margin-top: 12px;

    padding: 0 1px;
  `,

  link: css`
    text-decoration: none;
    color: #3a89c4;

    &:hover {
      text-decoration: underline;
    }
  `,

  button: css`
    border: none;
    outline: none;
    background: none;
    box-shadow: rgba(12, 12, 12, 0.1) 0px 1px 2px;

    height: 35px;
    margin-top: 12px;
    cursor: pointer;

    text-transform: uppercase;
    font-size: 13px;
    border-radius: 3px;

    background: #3a89c4;
    color: #ffffff;

    &:disabled {
      background: #747d8c;
      pointer-events: none;
    }

    &:focus {
      box-shadow: 0 0 0 3px rgba(58, 137, 196, 0.3);
    }
  `,

  social: {
    container: css`
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      flex-wrap: wrap;

      margin-top: 8px;
    `,

    disabled: css`
      opacity: 0.7;
      pointer-events: none;
    `,

    section: css`
      height: 32px;

      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      font-size: 13px;
      cursor: pointer;

      outline: none;

      &:focus {
        text-decoration: underline;

        & > span {
          opacity: 1;
        }
      }

      & > img {
        margin-right: 8px;
        margin-bottom: 1px;
      }

      & > span {
        opacity: 0.9;

        @media (max-width: 599px) {
          display: none;
        }
      }
    `,
  },
}
